<template>
    <!--@formatter:off-->
    <div>
        <div class="q_list" @mouseup.stop="changeActiveEditor" @focusin.stop="changeActiveEditorFromFocus">
            <div class="q_txt_area">
                <div class="q_txt">
                    <strong>{{$t('SurveyQuestionViewer_questionNumber', {number: questionNumber})}}</strong>
                    <span class="q_tit">
                        <Nl2br tag="output" :text="questionText"/>
                        <div class="q_info" v-if="questionDescText">{{questionDescText}}</div>
                    </span>
                </div>
            </div>

            <div class="bx_include_file" v-if="showImage">
                <div class="image">
                    <img :src="question.image.url" alt="" style="max-width: 100%">
                </div>
            </div>

            <div class="a_txt">
                <div class="box_time" style="overflow-x: scroll">
                    <table class="tbl_time" :class="{'data10': counselPeriods.length >= 10}" style="width:auto;min-width:100%">
                        <thead>
                        <tr>
                            <th></th>
                            <th
                                v-for="(day, dayIndex) in counselPeriods"
                                :key="`day-${dayIndex}`"
                            >
                                <div class="date" style="white-space: nowrap; min-width: 50px;">{{getPeriodDateFormat(day.value)}}</div>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="(timeSlot, timeSlotIndex) in counselTimeSlots"
                            :key="`timeSlot-${timeSlotIndex}`"
                        >
                            <th>
                                <div class="time" style="white-space: nowrap">{{timeSlot}}</div>
                            </th>
                            <td
                                v-for="(day, periodIndex) in counselPeriods"
                                :key="`time-${periodIndex}-${timeSlotIndex}`"
                            >
                                <div class="inner_cell">
                                    <div
                                        :class="{
                                           'impossible': !counselTimes[periodIndex][timeSlotIndex].value,
                                           'possible': counselTimes[periodIndex][timeSlotIndex.value]
                                        }"
                                    >
                                        <span class="blind">
                                            <template v-if="counselTimes[periodIndex][timeSlotIndex].value">
                                                {{$t('SurveyQuestionEditorParentCounselWeekTime_counselPossible')}}
                                            </template>
                                            <template v-else>
                                                {{$t('SurveyQuestionEditorParentCounselWeekTime_counselImpossible')}}
                                            </template>
                                        </span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <span v-if="noTimeOption !== PARENT_COUNSEL_WEEK_NO_TIME_OPTION.NOT_USE" class="bx_input_chk">
                    <input type="checkbox" class="input_chk" id="parent-counsel-week-no-time">
                    <label for="parent-counsel-week-no-time" class="input_lbl">{{$t('SurveyResponseParentCounselWeekTime_noTime')}}</label>
                </span>
            </div>

            <button ref="editButton" type="button" class="btn_edit">{{$t('SurveyQuestionViewer_edit')}}</button>
        </div>

        <SurveyQuestionViewer
            v-if="noTimeOption === PARENT_COUNSEL_WEEK_NO_TIME_OPTION.USE_TEXT"
            :question="question.questions[0]"
            :question-index="0"
            :parent-question-number="questionNumber"
            @changeActiveEditor="onChangeActiveEditor"
        >
            <template v-slot:innerHeader>
                <div class="sub_select">
                    {{$t('SurveyQuestionEditorParentCounselWeekTime_noTimeQuestionCondition', {n: questionNumber})}}
                </div>
            </template>
        </SurveyQuestionViewer>
    </div>
    <!--@formatter:on-->
</template>

<script>
import {toMonthDateDayFormat} from '@common/utils/date';
import SurveyQuestionViewer from '@iamteacherpc/components/editor/SurveyQuestionViewer';
import {PARENT_COUNSEL_WEEK_NO_TIME_OPTION} from '@common/consts/survey';

export default {
    name: "SurveyQuestionViewerParentCounselWeekTime",
    components: {SurveyQuestionViewer},
    extends: SurveyQuestionViewer,

    computed: {
        counselPeriods() {
            return this.question.counselPeriods;
        },

        counselTimeSlots() {
            return this.question.counselTimeSlots;
        },

        counselTimes() {
            return this.question.counselTimes;
        },

        noTimeOption() {
            return this.question.noTimeOption;
        },

        PARENT_COUNSEL_WEEK_NO_TIME_OPTION() {
            return PARENT_COUNSEL_WEEK_NO_TIME_OPTION;
        },
    },

    methods: {
        getPeriodDateFormat(date) {
            return toMonthDateDayFormat(date);
        },
    },
}
</script>

<style scoped>

</style>
